import React from 'react';
import Loadable from 'react-loadable';
import { Loader } from '../Basicos';
import ModalConsultaProfessorAnalitico from './ModalConsultaProfessorAnalitico';
import ModalConsultaCargaHorariaProfessorSintetico from './ModalConsultaCargaHorariaProfessorSintetico';
import ModalConsultaCargaHorariaProfessorAnalitico from './ModalConsultaCargaHorariaProfessorAnalitico';
import ModalConsultaProvasPendentes from './ModalConsultaProvasPendentes';

const ModalForm = Loadable({
    loader: () => import("./ModalForm"),
    loading: () => <Loader overlay fixed />
});
const ModalView = Loadable({
    loader: () => import("./ModalView"),
    loading: () => <Loader overlay fixed />
});

const ChaveamentoDeModal = (props) => {
    const { estrutura } = props;

    const tipoModal = estrutura?.modal?.tipo;

    switch (tipoModal) {
        case "modalForm":
            return (
                <ModalForm
                    {...props}
                    size={estrutura.modal.size}
                    data={estrutura}
                    modalClass={estrutura.modal.className}
                    modalBodyClass={estrutura.modal.modalBodyClass}
                />
            );
        case "modalView":
            return (
                <ModalView
                    {...props}
                    size={estrutura.modal.size}
                    data={estrutura}
                    modalClass={estrutura.modal.className}
                    modalBodyClass={estrutura.modal.modalBodyClass}
                />
            );
        case "modalConsultaProfessorAnalitico":
            return <ModalConsultaProfessorAnalitico data={estrutura} {...props} />
        case "modalConsultaCargaHorariaProfessorSintetico":
            return <ModalConsultaCargaHorariaProfessorSintetico data={estrutura} {...props} />
        case "modalConsultaCargaHorariaProfessorAnalitico":
            return <ModalConsultaCargaHorariaProfessorAnalitico data={estrutura} {...props} />
        case "modalConsultaProfessorProvaPendente":
            return <ModalConsultaProvasPendentes data={estrutura} {...props} />

        default:
            return null;
    }
}

export default ChaveamentoDeModal;
